module.exports = __webpack_public_path__ + "img/Jacqnarc-Banner.b1dbd927.jpg";